<template>
  <div class="collapse show collapse-horizontal aside col-lg-2" id="collapseWidthExample">
    <div class="aside-inner">
        <div class="aside-inner-title">MyPage</div>
        <div class="accordion"  id="accordionExample" >
          <template v-for="(depth1, index) in state.myDepth1"  :key="index">
            <template v-if="depth1.access">
              <h2 class="accordion-header" :id="depth1.key">
                  <router-link 
                    class="accordion-button accordion-icon-normal collapsed"
                    :to="depth1.link"
                  >
                    {{ depth1.name }}
                  </router-link>
              </h2>
            </template>
          </template>   
        </div>
    </div>
  </div>  
</template>
  
<script setup>
import { router } from '@/router';
import {computed} from 'vue'
import { useRoute } from "vue-router";
import { useUserStore } from '@/store/user';
const route = useRoute()
const userStore = useUserStore()

const state =  computed(()=>{
  const data = {
  myDepth1 :[
      {key : 'my1',name:'임시저장함', link : '/mp/MMP_AM_001' ,id:'M008M001',access:false},
      {key : 'my2',name:'알람 조회', link : '/mp/MMP_AM_002' ,id:'M008M002',access:false},
      {key : 'my3',name:'개인정보변경', link : '/mp/MMP_AM_003' ,id:'M008M003',access:false},
    ],
    keyStatus:''
  }


const menuList = Object.keys(data).filter(name => name.includes('Depth'))

menuList.forEach((depth)=>{
  data[depth].forEach((item)=>{
    if (userStore.user) {
      item.access = item.id ? userStore.user.mnUrl.includes(item.id) : true
    }
  })
})


Object.values(data).forEach(datum => {
  Object.values(datum).forEach(item => {
    if (item.link.toLowerCase() === route.path.toLowerCase()) {
      if(userStore.user && !item.access){
        alert('접근 불가한 페이지입니다.')
        router.push('/')
        return
      }
      data.keyStatus = item.key
    }
  })
})
  return data

})

</script>